import { useMemo } from 'react'
import { createContainer } from 'unstated-next'

import { useProductReviewFilters } from '../../lib/hooks/useProductReviewFilters'
import { useProductReviews } from '../../lib/hooks/useProductReviews'
import { useReviewsProductGroupDataContext } from '../ReviewsProductGroupDataService/useReviewsProductGroupData'

const useProductReviewsContainer = () => {
  const { data: productData } = useReviewsProductGroupDataContext()
  const productId = productData?.product?.shopifyId

  const { filters, pageNum } = useProductReviewFilters()

  const { productReviews, productReviewsError, productReviewsStatus } = useProductReviews({
    shopifyProductId: productId ?? '',
    filters,
    pageNum,
  })

  return useMemo(() => {
    return {
      results: productReviews,
      status: productReviewsStatus,
      error: productReviewsError,
    }
  }, [productReviews, productReviewsError, productReviewsStatus])
}

export const ProductReviewsContainer = createContainer(useProductReviewsContainer)
